var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col w-full h-screen justify-center items-center bg-purple-50"},[_c('div',{staticClass:"mb-8"},[_c('LookupMailbox',{staticClass:"w-168 bg-white",attrs:{"label":"to","hasError":false,"chipsProp":_vm.chips}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }